export const ListIconNavbar = [
  { icon: 'fluent:animal-cat-28-filled' },
  { icon: 'streamline:pets-allowed-solid' },
  { icon: 'fa6-solid:fish-fins' },
  { icon: 'icon-park-solid:other' },
]
